export const crearFonemaVacio = (valores = {}) => ({
  IdFonema: null,
  Simbolo: "",
  Nombre: "",
  Categoria: "",
  Estado: 1,
  ...valores
});

export const crearAreaComunicacionVacia = (valores = {}) => ({
  IdArea: null,
  Nombre: "",
  Activo: 1,
  ...valores
});

export const crearPacienteFonemaVacio = (valores = {}) => ({
  IdPacienteFonema: null,
  IdFonema: null,
  Simbolo: "",
  Nombre: "",
  Estado: "Pendiente",
  Prioridad: "Media",
  Observaciones: "",
  ...valores
});

export const crearAsignacionFonemaVacia = (valores = {}) => ({
  IdFonema: "",
  Prioridad: "Media",
  Observaciones: "",
  ...valores
});

export const crearObservacionLenguajeVacia = (valores = {}) => ({
  IdObservacion: null,
  IdArea: "",
  Area: "Lenguaje expresivo",
  Estado: "Pendiente",
  Texto: "",
  ...valores
});

export const catalogConfig = {
  fonemas: {
    titulo: "Fonemas",
    singular: "fonema",
    endpoint: "/fonemas.php",
    idKey: "IdFonema",
    stateKey: "Estado",
    campos: [
      { name: "Simbolo", label: "Simbolo", required: true },
      { name: "Nombre", label: "Nombre", required: true },
      { name: "Categoria", label: "Categoria" }
    ],
    emptyForm: crearFonemaVacio()
  },
  problemas: {
    titulo: "Problemas de comunicacion",
    singular: "problema de comunicacion",
    endpoint: "/lenguajeComunicacion.php",
    idKey: "IdArea",
    stateKey: "Activo",
    campos: [
      { name: "Nombre", label: "Nombre", required: true }
    ],
    emptyForm: crearAreaComunicacionVacia()
  }
};

export const normalizarEstado = (valor) => {
  if (valor === undefined || valor === null || valor === "") return 1;
  if (typeof valor === "string") {
    const estado = valor.toLowerCase();
    if (estado === "inactivo" || estado === "inactiva" || estado === "inactive" || estado === "0" || estado === "false") return 0;
  }

  return Number(valor) === 0 ? 0 : 1;
};

export const estaActivo = (item) => normalizarEstado(item?.Estado ?? item?.Activo) === 1;
